import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
import { MDCLinearProgress } from '@material/linear-progress';
const linearBlock = document.querySelector('.mdc-linear-progress')

Swiper.use([Navigation, Pagination, Lazy]);

function productSlider()  {
  new Swiper('.product-carousel', {
    slidesPerView: 1,
    spaceBetween: 20,
    slidesPerGroup: 1,
    preloadImages: false,
    lazy: true,
    speed: 500,
    // loop: true,
    breakpoints: {
      600: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        speed: 1000,
      },
      900: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1800: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
    },

    //pagination: {
    //  el: '.product-pagination',
    //},

    navigation: {
      nextEl: '.product-next',
      prevEl: '.product-prev',
    },
  });
}
productSlider();


const saleSlider = new Swiper('.sale-carousel', {
  slidesPerView: 1,
  spaceBetween: 20,
  slidesPerGroup: 1,
  speed: 500,
  preloadImages: false,
  lazy: true,
  breakpoints: {
    600: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      speed: 1000,
    },
    900: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    1800: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
  },

  //pagination: {
  //  el: '.sale-pagination',
  //},

  navigation: {
    nextEl: '.sale-carousel-next',
    prevEl: '.sale-carousel-prev',
  },
});

if (linearBlock) {
  const linearProgress = new MDCLinearProgress(linearBlock);
  const bestseller_buttons = document.querySelectorAll('.bestseller-button');
  const element_wrapper = document.querySelector('#BestsellerBlockWrapper')
  const element_title = document.querySelector('#BestsellerBlockTitle')
  linearProgress.close();
  bestseller_buttons.forEach(b => {
    b.addEventListener('click', function() {
      bestseller_buttons.forEach(b => {
          b.classList.remove('button--outlined--pressed')
      })
      b.classList.add('button--outlined--pressed')
      linearProgress.open();
      linearProgress.determinate = true;
      linearProgress.progress = 1;
      linearProgress.buffer = .5;
      fetch('/pl/bestseller/' + b.dataset.id)
      .then(result => {
        const p = Promise.resolve(result.json());
        p.then(v => {
          if (v.result) {
            element_wrapper.innerHTML = v.html_wrapper
            element_title.innerHTML = v.html_title
            linearProgress.close();
          }
        })
        .then(() => {
          setTimeout(() => {
            productSlider()
          }, 2000)
        })
      })
    })
  })
}
